import { Button } from '@mui/material';
import { ComponentProps } from 'react';
import clsx from 'clsx';
import { useTextButtonStyles } from './text-button.styles';
import { CircularProgress } from '@mui/material';

export type TextButtonColor = 'danger' | 'secondary' | 'primary';

export const TextButton: React.FC<
  Omit<ComponentProps<typeof Button>, 'color'> & {
    color: TextButtonColor;
    fontSize?: string;
    fontColor?: string;
    isLoading?: boolean;
  }
> = ({ color, fontSize, fontColor, isLoading, children, ...props }) => {
  const classes = useTextButtonStyles({ color, fontSize, fontColor });

  return (
    <Button
      disableElevation
      classes={{ contained: classes.contained }}
      className={clsx(classes.button, classes.root)}
      {...props}
    >
      {isLoading && <CircularProgress size={16} className={classes.spinner} />}
      <span style={{ visibility: isLoading ? 'hidden' : 'visible' }}>{children}</span>
    </Button>
  );
};
